import { useCallback } from 'react'
import { useTranslation } from '@/i18n'
import { NODE_TYPES } from './nodeIcons'
import type { KgFacet } from './filters'

/**
 * What a filter value is called, in the words the menu used to pick it —
 * one source for the menu rows AND the chips, so they cannot disagree.
 */
export const useFacetLabel = () => {
  const { t } = useTranslation()
  return useCallback(
    (facet: KgFacet, value: string): string => {
      switch (facet) {
        case 'types':
          return NODE_TYPES.includes(value as (typeof NODE_TYPES)[number])
            ? String(t(`knowledge_graph:types.${value}` as never, { defaultValue: value }))
            : value
        case 'uploaders':
          return value
      }
    },
    [t],
  )
}
